import "./buttons.scss";

import PlusIcon from "../icons/plusIcon.svg?react";

export const PlusButton = (props: {
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  hint?: string;
}): JSX.Element => {
  return (
    <button className="plus rg-button rg-red" onClick={props.onClick} title={props.hint} aria-label={props.hint}>
      <PlusIcon />
    </button>
  );
};
